import type { UserRoles } from '@iconik-io/shared-lib/src/utils/roles';

export const hasUploadRoles = (roles: UserRoles) =>
  roles.canCreateAssets &&
  roles.canCreateFormats &&
  roles.canWriteFormats &&
  roles.canWriteFiles &&
  (roles.webCanUpload || roles.webCanUploadLegacy);
